import { render, staticRenderFns } from "./supplierShippedDialog.vue?vue&type=template&id=266f456c&"
import script from "./supplierShippedDialog.vue?vue&type=script&lang=js&"
export * from "./supplierShippedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports